import React, { useState } from "react"
import Explainer from "../ExplainerModal";
import policyImplementation from "../FlowCharts/Policy-Implementation.png"

const ETrackerPolicyProgressExplainer = () => {
  const [isZoomed, setIsZoomed] = useState(false);

  return (
    <Explainer
      title="Policy & Regulatory Reforms Progress Explainer"
      content={
        <>
          <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: "#137A08" }}>
            📈 Tracking Policy Progress
          </h3>
          <p>
            The policy and regulatory reforms progress tracker visualizes each policy’s journey from initiation to
            implementation. A moving <span style={{ color: "blue", fontWeight: "bold" }}>🔵 blue dot</span> represents the
            current milestone, advancing as each stage is completed.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🏁 Milestones Breakdown
          </h3>
          <p>Each policy follows a structured process through six key stages:</p>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>1️⃣ Initiation</h4>
          <ul>
            <li>📝 Concept note development</li>
            <li>🤝 Stakeholder consultation on policy priorities</li>
            <li>📌 Prioritization of identified policy challenges</li>
            <li>🔍 Identification of policy challenge</li>
          </ul>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>2️⃣ Development</h4>
          <ul>
            <li>📢 Stakeholder consultation on the draft policy/bill/regulation</li>
            <li>🛠️ Development of draft policy/bill/regulation</li>
            <li>📊 Appraisal (e.g., regulatory impact assessment, cost-benefit analysis)</li>
          </ul>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>3️⃣ Validation</h4>
          <ul>
            <li>📋 Stakeholder validation workshops</li>
            <li>🔄 Review of draft policy/bill/regulation</li>
          </ul>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>4️⃣ Approval</h4>
          <ul>
            <li>📣 Socialization and policy advocacy</li>
            <li>📝 Cabinet feedback/modifications to policy/bill/regulation draft</li>
            <li>🏛️ Presentation to cabinet</li>
            <li>📄 Cabinet memo from lead ministry</li>
            <li>👥 Review by the committee of principal/permanent secretaries</li>
          </ul>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>5️⃣ Legislation</h4>
          <ul>
            <li>📜 Gazettement and publishing of policy/bill/regulation</li>
            <li>✍️ Presidential assent</li>
            <li>🏛️ Parliamentary debate and passage of bill/regulation</li>
            <li>📢 Public hearing</li>
            <li>📝 Organizing workshops with parliamentary select committee(s)</li>
            <li>📤 Submission to parliamentary select committee</li>
          </ul>

          <h4 style={{ fontSize: "16px", fontWeight: "bold", marginTop: "10px", color: "#137A08" }}>6️⃣ Implementation</h4>
          <ul>
            <li>📊 Post-implementation evaluation</li>
            <li>🔍 Monitoring & evaluation (assessing & advocating implementation)</li>
            <li>⚙️ Technical and financial capacity assessment</li>
            <li>📑 Development of Standard Operating Procedures (SOPs)</li>
            <li>🗣️ Interpretation & translation of law by policy enforcers</li>
            <li>✅ Development & approval of regulations</li>
          </ul>

           <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            ⚙️ Policy Implementation Model
        </h3>

        <div style={{ position: "relative", display: "inline-block" }}>
            {/* Flowchart Image */}
            <img
              src={policyImplementation}
              alt="Landscaping Process Flowchart"
              style={{ width: "100%", borderRadius: "8px", marginTop: "10px", cursor: "pointer" }}
              onClick={() => setIsZoomed(true)}
            />
            {/* Zoom Button (Magnifying Glass) */}
            <button
              onClick={() => setIsZoomed(true)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "20px",
                cursor: "pointer"
              }}
            >
              🔍 <span style={{ fontSize: "10px", color: "black" }}>Zoom</span>
            </button>
          </div>

      {/* Zoomed Image Modal */}
          {isZoomed && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "1000"
              }}
              onClick={() => setIsZoomed(false)}
            >
              <img
                src={policyImplementation}
                alt="Zoomed Landscaping Process Flowchart"
                style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
              />
            </div>
          )}

        </>
      }
    />
  );
};

export default ETrackerPolicyProgressExplainer;